const localStoragePrefix = 'storeeel_group_click'

export const groupClickRepository = {
  set(groupId, campaignId) {
    // 既存の全データを取得
    const existing = JSON.parse(localStorage.getItem(localStoragePrefix) || "{}");

    // groupIdごとのデータがなければ初期化
    if (!existing[groupId]) {
      existing[groupId] = {};
    }

    // CV 判定用のクリックログは期限なしで保持する
    existing[groupId][campaignId] = {};

    // 保存
    localStorage.setItem(localStoragePrefix, JSON.stringify(existing));
  },
  getAllValid() {
    const result = {};

    try {
      const data = JSON.parse(localStorage.getItem(localStoragePrefix) || '{}');

      Object.entries(data).forEach(([groupId, campaigns]) => {
        result[groupId] = campaigns;
      });

      return result;
    } catch {
      return {};
    }
  },
  removeExpiredCampaigns() {
    // 期限なし運用のため、互換用に残しつつ何もしない
  },
  remove(groupId, campaignId = null) {
    const data = JSON.parse(localStorage.getItem(localStoragePrefix) || "{}");

    if (campaignId !== null && campaignId !== undefined) {
      if (data[groupId] && campaignId in data[groupId]) {
        delete data[groupId][campaignId];
        if (Object.keys(data[groupId]).length === 0) delete data[groupId];
        localStorage.setItem(localStoragePrefix, JSON.stringify(data));
      }
      return;
    }

    if (groupId in data) {
      delete data[groupId];
      localStorage.setItem(localStoragePrefix, JSON.stringify(data));
    }
  }
}
